import React from 'react';
import type { RouteObject } from 'react-router-dom';

import TurnstilePage from 'pages/turnstile';

const turnstileRouteDefined: RouteObject = {
  path: '/turnstile',
  element: <TurnstilePage />,
};

export default turnstileRouteDefined;
